export default __webpack_public_path__ + "static/media/nepal_powerline_transmission.24fc3053.png";